import {
  notDesktop,
  styled,
  Text,
  useMutation,
  useTranslation,
} from '@obvio/app'
import {
  Form,
  FormPage,
  Stack,
  Submit,
  SubmitState,
  TextArea,
  TextInput,
} from '@obvio/ui'

import { FadeIn } from '../FadeIn'

import type { ReactElement } from 'react'

const MaxPage = styled(FormPage)`
  width: 80%;
  @media ${notDesktop} {
    width: 100%;
  }
`

const TextAreaSeparate = styled.div`
  margin-top: ${(theme) => theme.spacing.extraLarge} !important;
  width: 100%;
`

type FormData = {
  name: string
  email: string
  companyName: string | undefined
  phone: string | undefined
  message: string | undefined
}

export function FormContact(): ReactElement {
  const { t } = useTranslation()
  const [sendMessage] = useMutation('contactForm')

  const handleSubmit = async (values: FormData) => {
    await sendMessage(values)
    return SubmitState.OK
  }

  return (
    <Form contextOnly onSubmit={handleSubmit}>
      <MaxPage>
        <Stack kind="vertical" spacing="medium">
          <TextInput name="name" label="Full name" />
          <TextInput name="email" label="E-mail" />
          <TextInput name="companyName" label="Company name" optional />
          <TextInput name="phone" label="Phone number" optional />
          <TextAreaSeparate>
            <TextArea
              name="message"
              label="Your message"
              rows={10}
              placeholder="Enquiry message (250 character limit)"
              optional
            />
          </TextAreaSeparate>
          <Submit>SEND APPLICATION</Submit>
        </Stack>
      </MaxPage>
      <MaxPage successPage>
        <FadeIn>
          <Text tag="h2" as="h4">
            {t('joinForm.sent')}
          </Text>
        </FadeIn>
      </MaxPage>
    </Form>
  )
}
